import createVueComponent from '../createVueComponent';

const Library = createVueComponent('LibraryIcon', [
  ['path', { d: 'M16 6l4 14' }],
  ['path', { d: 'M12 6v14' }],
  ['path', { d: 'M8 8v12' }],
  ['path', { d: 'M4 4v16' }],
]);

export default Library;
